import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import { media } from '@clds/style-utils';
import { CookbookFilterPanel, PageHeader } from '../../common';

export const FilterPanelWrapper = styled.div`
  width: 100%;
  border-top: 1px solid ${globalTheme.palette.secondaryAlt};
`;

export const Wrapper = styled.div`
  margin: ${globalTheme.spacing.lg} 0;
`;

export const PageTitle = styled.div`
  ${typography.lg.regular};
  display: flex;
  align-items: center;
  padding-left: ${globalTheme.spacing.sm};

  @media ${media.tablet({ maxOnly: true })} {
    padding: ${globalTheme.spacing.md} ${globalTheme.spacing.lg};
    border-bottom: 1px solid ${globalTheme.palette.secondaryAlt};
  }
`;

export const HeaderContainer = styled.div`
  width: 1180px;
  max-width: 100%;
  margin: 0 auto;
`;

export const Container = styled.div`
  width: 1180px;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 ${globalTheme.spacing.sm};
`;

export const CardWrapper = styled.div`
  &:not(:first-of-type) {
    margin-top: ${globalTheme.spacing.md};
  }
`;

export const PageStretcher = styled.div`
  padding: 100px 0;
`;

export const ListSearch = styled(PageHeader.Search)`
  padding: ${globalTheme.spacing.sm};
`;

export const StyledCookbookFilterPanel = styled(CookbookFilterPanel)`
  display: flex;
  justify-content: center;

  @media ${media.wide()}, ${media.desktop()}, ${media.tablet()} {
    justify-content: flex-start;
  }

  @media ${media.phone()} {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;
